import { DialogModule } from '@angular/cdk/dialog';
import { AsyncPipe, KeyValuePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { NetworkService } from '../../../network.service';
import { LfwRouterService } from '../../../route/lfw-router.service';
import { AppToolbarButtonComponent } from '../../../shared/components/app-toolbar-button/app-toolbar-button.component';
import { AppToolbarDividerComponent } from '../../../shared/components/app-toolbar-divider/app-toolbar-divider.component';
import { AppToolbarTextComponent } from '../../../shared/components/app-toolbar-text/app-toolbar-text.component';
import { FormViewToolbarComponent } from '../../components/form-toolbar/form-view-toolbar.component';
import { OfflineOrders } from '../offline-forms.client';
import { OfflineFormsProvider } from '../offline-forms.provider';
import { OfflineOrderListItemComponent } from '../offline-order-list-item/offline-order-list-item.component';
import { IndexDbSizeDialogComponent } from './index-db-size-dialog/index-db-size-dialog.component';

@Component({
  selector: 'lfw-offline-order-list',
  templateUrl: './offline-order-view.component.html',
  styleUrls: ['./offline-order-view.component.scss'],
  imports: [
    OfflineOrderListItemComponent,
    MatListModule,
    KeyValuePipe,
    AsyncPipe,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    DialogModule,
    MatMenuModule,
    MatIcon,
    AppToolbarButtonComponent,
    AppToolbarTextComponent,
    FormViewToolbarComponent,
    AppToolbarDividerComponent,
    TranslatePipe
  ],
  providers: [OfflineFormsProvider]
})
export class OfflineOrderViewComponent {
  readonly orders$ = input.required<Observable<OfflineOrders>>();
  readonly showTemporaryOrderList = input.required();

  private readonly routerService = inject(LfwRouterService);
  private readonly dialog = inject(MatDialog);

  private readonly networkState = toSignal(inject(NetworkService).state$);

  readonly showOnlyOnline = computed(() => this.networkState() === 'online');

  getToolbarText(): string {
    return this.showTemporaryOrderList() ? 'COMMANDS.TEMPORARYOFFLINEORDERS' : 'COMMANDS.OFFLINEORDERS';
  }

  close(): void {
    this.routerService.navigateToOrdersRoot();
  }

  openInfo(): void {
    this.dialog.open(IndexDbSizeDialogComponent, { width: '400px' });
  }
}
